// @flow
import type { StatelessFunctionalComponent } from 'react';
import styled from 'styled-components';

const APersonalesWrapper: StatelessFunctionalComponent<*> = styled.div`
  padding: 20px 10px !important;
  
  .overwrite-inputs {
    text-align: left;
    .input-img-container {
      display: none;
    }
    .floating-label {
      > input {
        box-shadow: none;
        background: 0;
      }
    }
  }

  .APersonales {
    &-formRow {
      margin-top: 16px;
      display: flex;
      justify-content: center;

      &-1 {
        margin-top: 16px;
        max-width: 450px;
        text-align: center;
        margin: auto !important;
      }
    }

    @media (max-width: 700px) {
      &-formRow {
        flex-direction: column;
      }
    }

    &-beneficiaries {
      &-container {
        display: grid;
        grid-gap: 15px;
        padding: 10px 15px;
        margin: 15px 0px;
        grid-template: 'docu name date perc'
                       'text text cont cont' /
                        1.5fr 2fr 1fr  1fr;
        background: rgba(0, 0, 0, 0.03);
        border-radius: 15px;
      }

      &-docu { grid-area: docu; }
      &-name { grid-area: name; }
      &-date { grid-area: date; }
      &-perc { grid-area: perc; }
      &-cont { grid-area: cont; }
      &-text { grid-area: text; padding: 5px; }

      @media (max-width: 700px){
        &-container {
          grid-template: 'docu docu date date'
                         'name name perc perc'
                         'cont cont cont cont'
                         'text text text text' /
                          2fr  2fr  1fr  1fr;
        }
      }
    }

    &-checks {
      display: flex;
      padding: 0px 15px;
      margin-top: 25px;
      flex-direction: row;
      color: var(--text-color-1);
    }

    &-options {
      display: flex;
      justify-content: center;
      margin-bottom: 10px;
      flex-direction: row;

      &-check {
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: center;
        justify-content: center;
        margin: auto 0;
        padding: 0px 20px;
      }
    }

    @media (max-width: 700px){
      &-options {
        flex-direction: column;
        margin-right: 5%;
      }
    }

    &-option {
      display: grid;
      grid-template-columns: 1fr 2fr;
      align-items: center;
      justify-content: center;
      margin: auto 0;
      padding: 0px 30px;

      &-text {
        margin-right: 20px;
        color: #525252;
      }

      &-off {
        color: var(--inactive-button);
      }

      &-check {
        font-size: 16px;
        color: #444;
        display: flex;
        align-items: center;
        margin: 0 20px;

        label {
          cursor: pointer;
          display: flex;
          align-items: center;
        }

        label span {
          padding-right: 10px;
        }
      }
    }

    &-buttons {
      display: flex;
      padding: 0px 15px;
      margin-top: 25px;
      flex-direction: row;
      color: var(--text-color-1);
      
      &-button {
        margin: 0px 20px;
        min-width: 0px;
        max-height: 15px;
        font-size: 4em !important;

        > span {
          max-height: 0;
        }
      }

      &-text {
        margin-right: 20px;
        color: #525252;
      }
    }

    &-radioWrapper {
      border: 1px solid rgb(151, 151, 151, .4);
      border-radius: 4px;
      width: 26px;
      height: 26px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;

      input {
        opacity: 0;
        position: absolute;
      }

      &--on:after {
        content: '';
        display: block;
        width: 5px;
        height: 12px;
        border: solid var(--blue-light-color);
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
        position: relative;
        top: -1px;
      }
    }
  }

  .Quotation {
    &-container {
      display: grid;
      grid-template-columns: 49% 49%;
      grid-gap: 35px;
      padding: 25px 50px 0px;
      justify-content: center;
    }

    &-slider {
        display: none;
      }

    @media (max-width: 650px) {
      &-container {
        display: none;
      }

      &-slider {
        display: grid;
        grid-template-columns: 100%;
        grid-gap: 35px;
        padding: 25px 15px 0px;
        justify-content: center;
      }

      &-option {
        margin: 10px;
      }
    }

    &-selected {
      border-radius: 3px;
      box-shadow: 0px 0px 15px 4px rgba(0, 0, 0, 0.83);
    }

    &-silver {
      cursor: pointer;
      border-radius: 3px;
      .Price-value-container-on {
        background-image: linear-gradient(292deg, #5f5f5f, #c5c5c5), 
                          linear-gradient(rgba(0, 0, 0, 0.1), 
                          rgba(0, 0, 0, 0.1));
      }
    }

    &-gold {
      cursor: pointer;    
      border-radius: 3px;
      .Price-value-container-on {
        background-image: linear-gradient(112deg, #f7ae2d, #80561b), 
                          linear-gradient(rgba(0, 0, 0, 0.1), 
                          rgba(0, 0, 0, 0.1));
      }
    }
  }
`;

export default APersonalesWrapper;
